import {checkShowPermit, formatMinToNtcTime, getPeriodicTimes} from "@/tools/utils";
import {commonConfig, momentFormat} from "@/config/common";
import mobRouteMeta from "@/views/front/router/routerMeta";

export default {
  computed: {
    showPeriodic() {
      const {query} = this.$route;
      return !this.cMDoc || !this.cMDoc.isPeriodic
        || this.$route.name === mobRouteMeta.periodicMeetingEdit.name  // 移动端
        || query.edit_periodic  // PC端
    },
    periodicDays() {
      if (!checkShowPermit(this.$store.state.permissionList || [], "periodicReserve")) return 0;

      const {roomId, allowPeriodic, periodicDays: roomPeriodicDays} = this.dataSource.chosenRoom || {};
      // 会议室不支持预约周期会议
      if (roomId && !allowPeriodic) return 0;
      if (roomPeriodicDays) return roomPeriodicDays;

      const {periodicDays: sysPeriodicDays} = this.$store.state.sysConfig;
      return sysPeriodicDays || 0
    },
    periodicTypesMap() {
      const date = moment(this.dataSource.startTime).toDate();
      return {
        daily: commonConfig.periodicTypes.daily.label,
        weekdays: commonConfig.periodicTypes.weekdays.label,
        weekly: commonConfig.periodicTypes.weekly.label + `（周${commonConfig.weekInfo[date.getDay()]}）`,
        fortnightly: commonConfig.periodicTypes.fortnightly.label + `（周${commonConfig.weekInfo[date.getDay()]}）`,
        monthly: commonConfig.periodicTypes.monthly.label + `（${date.getDate()}日）`,
        custom: commonConfig.periodicTypes.custom.label,
      }
    },
    periodicTypeCols() {
      return Object.keys(this.periodicTypesMap).map(k => ({value: k, text: this.periodicTypesMap[k]}))
    },
    periodicTimes() {
      const {periodicType, untilDate} = this.dataSource.periodicInfo;
      if (untilDate) {
        return getPeriodicTimes(periodicType, untilDate, new Date(this.dataSource.startTime));
      }
      return 1
    },
    periodicInfoCN() {
      const {periodicType, untilDate} = this.dataSource.periodicInfo
      if (periodicType && untilDate) {
        return {
          periodicType: commonConfig.periodicTypes[periodicType].label,
          untilDate: moment(untilDate).format(momentFormat.dateFormatDayCN),
          periodicTimes: `${this.periodicTimes}场会议`
        }
      }
      return null;
    },
    untilDateDiffStartTime() {
      const {periodicInfo, startTime} = this.dataSource;
      if (periodicInfo && periodicInfo.untilDate) {
        return moment(periodicInfo.untilDate).diff(moment(startTime).startOf('d'), 'd')
      }
      return 0
    },
  },
  methods: {
    checkPeriodicInfo() {
      let periodicInfo = null;
      if (this.periodicDays && this.dataProxy.isPeriodic) {
        const srcPeriodicInfo = this.dataSource.periodicInfo;
        periodicInfo = {...srcPeriodicInfo};
        if (!srcPeriodicInfo.periodicType) {
          return "请选择周期会议的重复频率"
        }
        if (srcPeriodicInfo.periodicType === commonConfig.periodicTypes.custom.value) {
          if (!srcPeriodicInfo.selection.length) {
            return "请选择周期会议的具体时间段"
          }
          let err = "";
          srcPeriodicInfo.selection.some(e => {
            const {startTime, endTime} = e;
            if (this.meetingDurationLimit) {
              const diffMin = moment(endTime).diff(moment(startTime), 'm');
              if (diffMin > this.meetingDurationLimit) {
                err = `周期会议时长超出单场会议时长限制：${formatMinToNtcTime(this.meetingDurationLimit)}`;
                return true
              }
            }
          });
          if (err) return err;

          // 数据过滤
          periodicInfo.selection = srcPeriodicInfo.selection.map(e => ({
            startTime: e.startTime,
            endTime: e.endTime,
          }));
          periodicInfo.untilDate = 0
        } else {
          if (!srcPeriodicInfo.untilDate) {
            return "请选择周期会议结束重复时间"
          }
          if (this.untilDateDiffStartTime < 0) {
            return `会议开始日期不能大于周期会议结束重复日期：${moment(srcPeriodicInfo.untilDate).format(momentFormat.dateFormatDayCN)}`
          }
          periodicInfo.untilDate = srcPeriodicInfo.untilDate.valueOf();
          periodicInfo.selection = []
        }
      } else {
        this.dataProxy.isPeriodic = false;
      }
      this.dataSource.formattedPeriodicInfo = periodicInfo;
    },
  }
}
